/**
 * Keyed by election AND party: a cancellation ledger is party-scoped, and two parties viewing
 * one election (a Super Admin switching party) must never share a cache entry.
 */
export const cancellationKeys = {
	all: ['cancellations'] as const,
	election: (electionId: number) => [...cancellationKeys.all, electionId] as const,
	scope: (electionId: number, partyKey: number) => [...cancellationKeys.election(electionId), partyKey] as const,
	capabilities: (electionId: number) => [...cancellationKeys.all, 'capabilities', electionId] as const,
	list: (electionId: number, partyKey: number, params: string) =>
		[...cancellationKeys.scope(electionId, partyKey), 'list', params] as const,
	active: (electionId: number, partyKey: number) => [...cancellationKeys.scope(electionId, partyKey), 'active'] as const,
	impactSummary: (electionId: number, partyKey: number, params: string) =>
		[...cancellationKeys.scope(electionId, partyKey), 'impact-summary', params] as const,
	impact: (electionId: number, partyKey: number, id: number) =>
		[...cancellationKeys.scope(electionId, partyKey), 'impact', id] as const,
	evidence: (electionId: number, partyKey: number, id: number) =>
		[...cancellationKeys.scope(electionId, partyKey), 'evidence', id] as const,
	alertSettings: (electionId: number, partyKey: number) =>
		[...cancellationKeys.scope(electionId, partyKey), 'alert-settings'] as const,
	recipients: (partyKey: number) => [...cancellationKeys.all, 'recipients', partyKey] as const,
};
